// Color options for category creation
export const COLOR_OPTIONS = [
  { value: '#6D28D9', label: 'Purple', preview: '#6D28D9' },
  { value: '#10B981', label: 'Emerald', preview: '#10B981' },
  { value: '#F59E0B', label: 'Amber', preview: '#F59E0B' },
  { value: '#EF4444', label: 'Red', preview: '#EF4444' },
  { value: '#3B82F6', label: 'Blue', preview: '#3B82F6' },
  { value: '#EC4899', label: 'Pink', preview: '#EC4899' },
  { value: '#6B7280', label: 'Gray', preview: '#6B7280' },
  { value: '#8B5CF6', label: 'Violet', preview: '#8B5CF6' },
];

// Emoji options for category creation
export const EMOJI_OPTIONS = [
  '🤢', '🤒', '😷', '🤧', '😪', '😣', '🔴', '💊', 
  '🌡️', '🩹', '🧠', '💙', '⚡', '🔥', '❄️', '📝'
];